import { NamedEntityState } from '@ngrx/signals/entities';
import { ServiceCodesEnum } from '../service-codes/service-codes';
import { BmiTreatmentInfo, TablePagination, UserBMI } from './bmi-api.model';

export enum WeightLossCodesEnum {
  WEI_F = ServiceCodesEnum.WEI_F_WEIGHT_LOSS_TREATMENT,
  WEI_R = ServiceCodesEnum.WEI_R_WEIGHT_LOSS_RETURN,
}

export enum FivePercentWeightLossStatusEnum {
  NOT_DUE = 'NOT_DUE',
  DUE = 'DUE',
  MET = 'MET',
  NOT_MET = 'NOT_MET',
  TSD_UNKNOWN = 'TSD_UNKNOWN',
}

export interface BMIDialogData {
  patientId: number;
  visitId?: number;
}

export interface BmiStoreFilter {
  serviceCodes: ServiceCodesEnum[];
}

export enum BmiEntitiesEnum {
  COLLECTION_NAME = 'bmiItem',
}

export interface BmiItemEntityState extends NamedEntityState<UserBMI, BmiEntitiesEnum.COLLECTION_NAME> {
  bmiItemEntities: UserBMI[];
}

export interface BaseBmiStoreState {
  treatmentDetails: BmiTreatmentInfo;
  patientUserId: number;
  bmiListOptions: BmiStoreListOptions;
  itemBeingEditedId: number | null;
}

export type BmiStoreState = BaseBmiStoreState & BmiItemEntityState;

export interface BmiStoreListOptions {
  pagination: TablePagination;
  filterBy: BmiStoreFilter;
  sort: 'asc' | 'desc';
}

export interface LoadBmiDataReq {
  userId: number;
  limit?: number;
  order?: 'asc' | 'desc';
  serviceCodesFilter?: ServiceCodesEnum[];
  offset?: number;
  visitId?: number;
}

export interface SaveBmiItemReq {
  user_id: number;
  order_id: number;
  bmi_id?: number;
  height: number;
  weight: number;
  mail_order_fill_request_id: number;
}

export interface TreatmentStartInfoSaveReq {
  user_id: number;
  order_id: number;
  start_date: string;
  start_weight: number;
  bmi_id?: number;
}
